'use client';

import { FaRegHeart, FaHeart } from 'react-icons/fa6';

import { useState } from 'react';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import axios from '@/lib/axios';
import { toast } from 'react-toastify';
import { pushToDataLayer, toGa4Item } from '@/features/gtm/gtmUtils';
import { useAuth } from '@/features/authentication/hooks/auth';
import { usePathname, useRouter } from 'next/navigation';

const ProductDetailsWishlist = ({
  product,
}: {
  product: any;
}) => {
  const { user } = useAuth();
  const pathname = usePathname();
  const router = useRouter();
  const { data: wishlists, mutate } = useFetcherCSR(
    user && `/api/v2/wishlists`
  );
  const includeWishlist = wishlists?.data?.some(
    (item: any) => item?.product?.id === product?.id
  );

  const [isWishlist, setIsWishlist] = useState(includeWishlist || false);

  const handleAddToWishList = async () => {
    if (!user) {
      router.push(`/login?redirect=${pathname}`);
      return;
    }

    try {
      const res = await axios.get(
        `/api/v2/wishlists-add-product?product_id=${product?.id}`
      );
      if (res.status === 200) {
        toast.success(res?.data?.message);
        mutate();
        setIsWishlist(true);
        const item = toGa4Item(product);
        pushToDataLayer('add_to_wishlist', {
          ecommerce: {
            value: item.price,
            currency: 'BDT',
            items: [item],
          },
        });
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRemoveWishList = async () => {
    try {
      const res = await axios.get(
        `/api/v2/wishlists-remove-product?product_id=${product?.id}`
      );

      if (res.status === 200) {
        toast.error(res?.data?.message);
        mutate();
        setIsWishlist(false);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <button
        onClick={isWishlist ? handleRemoveWishList : handleAddToWishList}
        className="product-details__fav-btn border-0"
        aria-label="Toggle Wishlist"
      >
        {isWishlist ? (
          <FaHeart style={{ color: '#e5456d' }} className="text-badge" />
        ) : (
          <FaRegHeart style={{ color: 'gray' }} />
        )}
      </button>
    </>
  );
};

export default ProductDetailsWishlist;
